import SashiDo from 'lib/SashiDo';
import { Link } from 'react-router';

import React, { Component } from 'react';
import Icon from 'components/Icon/Icon.react';
import Notification from 'components/Notification/Notification.react';

import styles from './Login.scss';


export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
      note: null,
    };

    this.handleKey = this.handleKey.bind(this);
    this.handleSubmitButton = this.handleSubmitButton.bind(this);
    this.setFocus = this.setFocus.bind(this);
  }

  componentDidMount() {
    SashiDo.logOut();

    document.body.addEventListener('keydown', this.handleKey);
  }

  componentWillUnmount() {
    document.body.removeEventListener('keydown', this.handleKey);
  }

  setFocus() {
    const username = this.usernameInput;
    const password = this.passwordInput;

    username.value = '';
    password.value = '';
  }

  handleForgot(e) {
    e.preventDefault();
    const username = this.usernameInput.value;

    if (username) {
      SashiDo.forgottenPassword({ username })
        .then(({ success, error }) => {
          if (success || error) {
            this.setState({
              note: {
                type: 'info',
                message: "We've sent you an email with further instructions.",
              },
            });
          }
        });
    } else {
      this.setState({
        note: {
          type: 'error',
          message: 'Please enter an email address first.',
        },
      });
    }

    this.setFocus();
  }

  handleKey(e) {
    const keyCode = e.keyCode || e.which;
    switch (keyCode) {
      case 13:
        this.handleSubmitButton(this);
        break;
    }
  }

  handleSubmitButton() {
    setTimeout(() => {
      const username = this.usernameInput.value;
      const password = this.passwordInput.value;

      if (!!username && !!password) {
        this.setState({
          isActive: true,
          note: null,
        });

        SashiDo.logIn({ username, password }).then(({ success, error }) => {
          if (success) {
            setTimeout(() => {
              const pathname = localStorage.getItem('sashido-redirect') || '/products/apps';

              if (!window.sashidoLock) {
                window.location = pathname;
              }

              window.localStorage.removeItem('sashido-redirect');
            }, 1000);
          }

          if (error) {
            setTimeout(() => {
              this.setState({
                isActive: false,
                note: {
                  type: 'error',
                  message: error,
                },
              });
            }, 1000);
          }
        });
      } else {
        this.setState({
          isActive: false,
          note: {
            type: 'error',
            message: 'Missing email or password.',
          },
        });
        this.setFocus();
      }
    }, 100);
  }

  render() {
    const classes = [styles.content];

    const alertMessage = null;

    if (this.state.isActive) {
      classes.push(styles.loading);
    }

    return (
      <div className={[styles.login, styles.flex].join(" ")}>
        <div>
          <div className={styles.showEffect} />
          <div className={styles.wrapper}>
            <Link to="/login" className={styles.logo}>
              <img src="/assets/images/logo.svg" width="180" alt="SashiDo" />
            </Link>
            <div className={classes.join(' ')}>
              <form action="/login" data-loading-text="Log In" className={styles.form}>
                <p className={styles.title}>Log In</p>
                <div className={styles.inputHolder}>
                  <input
                    name="username"
                    placeholder="email address"
                    className={styles.username}
                    type="email"
                    ref={(input) => {
                      if (input) {
                        input.focus();
                        this.usernameInput = input;
                      }
                    }} />
                  <div className={styles.inputIconHolder}>
                    <Icon name="icon-envelope" width={16} height={16} fill="#fff" />
                  </div>
                </div>

                <div className={styles.inputHolder}>
                  <input
                    name="password"
                    placeholder="password"
                    className={styles.password}
                    type="password"
                    ref={(input) => {
                      this.passwordInput = input;
                    }} />
                  <div className={styles.inputIconHolder}>
                    <Icon name="icon-lock" width={16} height={16} fill="#fff" />
                  </div>
                </div>
                <p>
                  <a
                    href="/forgot"
                    className={styles.forgot}
                    onClick={this.handleForgot.bind(this)}>Forgot?
                </a>
                </p>
                <a
                  id="submit"
                  href="javascript:;"
                  className={styles.button}
                  onClick={this.handleSubmitButton.bind(this)}>
                  <i className={styles.spinner} /><span>Log In</span>
                </a>
              </form>
            </div>
            {/* <a href='http://www.sashido.io/#GetStarted' className={styles.signUp}>New to SashiDo.io? Sign up</a> */}
            <a href="/register" className={styles.signUp}>New to SashiDo.io? Sign Up Now!</a>
          </div>
          <Notification note={this.state.note} fullscreen close />
        </div>
      </div>
    );
  }
}
